import { Button } from "@/components/ui/button";
import type { Subcollection } from "@/modules/snapshots/snapshotCollection.types";

import { AddToSubcollection } from "./AddToSubcollection";

interface Props {
  selectedIds: Set<string>;
  snapshotCollectionId: string;
  subcollectionId?: string;
  buttonSize?: React.ComponentProps<typeof Button>["size"];
  onSubcollectionCreated?: (subcollection: Subcollection) => void;
  disabled?: boolean;
  contractFamilyProjection?: boolean;
}

export const SnapshotCollectionsOutcomesToolbar = ({
  selectedIds,
  snapshotCollectionId,
  subcollectionId,
  buttonSize,
  onSubcollectionCreated,
  disabled = false,
  contractFamilyProjection = false,
}: Props) => {
  const hasSelection = selectedIds.size > 0;
  const isSubcollectionView = !!subcollectionId;

  if (!hasSelection || isSubcollectionView) return null;

  return (
    <div className="flex items-center gap-2">
      <AddToSubcollection
        size={buttonSize}
        snapshotCollectionId={snapshotCollectionId}
        selectedSnapshotIds={Array.from(selectedIds)}
        onSubcollectionCreated={onSubcollectionCreated}
        disabled={disabled}
        contractFamilyProjection={contractFamilyProjection}
      />
    </div>
  );
};
